import { ACTION_TYPES } from "./types";

const {
  OPEN_AUTH_MODAL,
  CLOSE_AUTH_MODAL,
  OPEN_PLANS_MODAL,
  CLOSE_PLANS_MODAL,
  OPEN_SKILL_COURSE_PURCHASE_SUCCESS_MODAL,
  CLOSE_SKILL_COURSE_PURCHASE_SUCCESS_MODAL,
  OPEN_INTERNSHIP_COURSE_PURCHASE_MODAL,
  CLOSE_INTERNSHIP_COURSE_PURCHASE_MODAL,
  OPEN_INTERNSHIP_COURSE_PURCHASE_SUCCESS_MODAL,
  CLOSE_INTERNSHIP_COURSE_PURCHASE_SUCCESS_MODAL,
} = ACTION_TYPES;

export const openAuthModal = () => {
  return { type: OPEN_AUTH_MODAL };
};

export const closeAuthModal = () => {
  return { type: CLOSE_AUTH_MODAL };
};

export const openPlansModal = () => {
  return { type: OPEN_PLANS_MODAL };
};

export const closePlansModal = () => {
  return { type: CLOSE_PLANS_MODAL };
};

export const openSkillCoursePurchaseSuccessModal = () => {
  return { type: OPEN_SKILL_COURSE_PURCHASE_SUCCESS_MODAL };
};

export const closeSkillCoursePurchaseSuccessModal = () => {
  return { type: CLOSE_SKILL_COURSE_PURCHASE_SUCCESS_MODAL };
};

export const openInternshipCoursePurchaseModal = () => {
  return { type: OPEN_INTERNSHIP_COURSE_PURCHASE_MODAL };
};

export const closeInternshipCoursePurchaseModal = () => {
  return { type: CLOSE_INTERNSHIP_COURSE_PURCHASE_MODAL };
};

export const openInternshipCoursePurchaseSuccessModal = () => {
  return { type: OPEN_INTERNSHIP_COURSE_PURCHASE_SUCCESS_MODAL };
};

export const closeInternshipCoursePurchaseSuccessModal = () => {
  return { type: CLOSE_INTERNSHIP_COURSE_PURCHASE_SUCCESS_MODAL };
};
